import {
  MutationFunction,
  QueryKey,
  useMutation as reactQueryMutation,
  UseMutationOptions,
  useQueryClient,
} from '@tanstack/react-query';
import { AxiosError } from 'axios';
import { extractReactQueryKey } from 'utils';

type Item = {
  id?: number;
};

interface IContext {
  newData: object & Item[];
}

export const useOptimisticDelete = <TError = AxiosError>(
  key: QueryKey,
  query: MutationFunction<undefined, number>,
  options?: UseMutationOptions<undefined, TError, number, IContext>,
) => {
  const queryClient = useQueryClient();

  return reactQueryMutation({
    mutationFn: query,
    ...options,
    onSuccess: (data, deletedId, context, d) => {
      queryClient.invalidateQueries({ queryKey: extractReactQueryKey(key) });

      queryClient.setQueryData([...key, deletedId], (oldItem: any) => ({
        ...oldItem,
        deletedAt: new Date().toISOString(),
      }));

      const oldItems = queryClient.getQueryData<(object & Item)[]>(extractReactQueryKey(key)) || [];
      const newData = oldItems.filter((x) => x.id !== deletedId);
      queryClient.setQueryData([key], newData);

      options?.onSuccess?.(data, deletedId, context, d);
    },
  });
};
